<template>
    <div class="file-uploader">
        <div class="file has-name is-fullwidth" :class="{ 'is-danger': errors.hasError( 'files.'+index ) }">
            <label class="file-label">
                <input @change="handleInput" :multiple="multiple" class="file-input" type="file" :name="name">
                <span class="file-cta">
                  <span class="file-icon"><i class="fas fa-upload"></i></span>
                  <span class="file-label" v-text="lang('Seleziona File')"></span>
                </span>
                <span class="file-name" v-text="filename"></span>
            </label>
            <span @click="removeFile" class="remove-file"><span>
                <span class="icon"><i class="fas fa-trash"></i></span> {{ lang('Rimuovi File') }}
            </span></span>
        </div>
        <p class="help is-danger" v-text="errors.get('files.'+index)"></p>
    </div>
</template>
<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            file: {
                type: File,
                required: false
            },
            index: {
                type: Number,
                required: true
            },
            multiple: {
                type: Boolean,
                required: false,
                default: false
            },
            errors: {
                type: Object,
                required: false
            }
        },
        mounted() {
            if( typeof this.file === 'object' ) {
                this.fileObject = this.file;
                this.filename = this.file.name;
            }
        },
        data() {
            return {
                fileObject: null,
                filename: ''
            }
        },
        methods: {
            handleInput(e) {
                if( ! e.target.files.length ) return;
                if( this.multiple ) return this.$emit('selected', e.target.files, this.index);

                this.fileObject = e.target.files[0];
                this.filename = this.fileObject.name;
                this.$emit('selected', this.fileObject, this.index);
            },
            removeFile() {
                this.$emit('remove', this.index)
            }
        },
        watch: {
            file( file ) {
                this.fileObject = file;
                this.filename = file.name;
            }
        }
    }
</script>